import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {Group} from '../../models/group';
import {Entity} from '../../models/entity';
import {ApiService} from '../../services/api/api.service';
import {MessagesService} from '../../services/messages/messages.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {MessageImageData} from '../../models/message-image-data';
import {HttpErrorResponse} from '@angular/common/http';
import {ToastNotificationService} from '../../services/toast-notification/toast-notification.service';
import {UserService} from '../../services/user/user.service';
import {Paginator} from '../../models/paginator';
import {EntitiesService} from '../../services/entities/entities.service';
import {ChatChannelComponent} from '../chat-channel/chat-channel.component';
import {debounce} from 'ts-debounce';
import * as $ from 'jquery';
import {NewMessageObserverService} from '../../services/new-message-observer/new-message-observer.service';
import {
    displayMessageTimestamp,
    sortByNewestTimestamp,
} from '../../helpers/message-display/message-display';

@Component({
    selector: 'ngx-messenger',
    templateUrl: './messenger.component.html',
    styleUrls: ['./messenger.component.scss']
})
export class MessengerComponent implements OnInit {
    @Input('messageType') messageType: string = 'chat';
    @Input('activeId') activeId: number = null;
    private readonly messageChannelSort = 'sort=-updated_at,-created_at';

    @ViewChild('file') file;
    @ViewChild('chatChannel') chatChannel: ChatChannelComponent;

    public id: number = 0;
    public group: Group = new Group();
    public selectedEntity: Entity = null;

    public categories: Array<string> = [];

    public searchString: string = '';

    public massMessageStep: number = 0;
    public base64UploadedFiles: Array<MessageImageData> = [];
    public failedFiles: Array<MessageImageData> = [];
    public diaryMessage: string = '';

    public modalSelectedEntities: Array<Entity> = [];

    public currentChannel = null;

    // File Upload
    private filesToUpload: Array<any> = [];

    // Infinite Scroll Entities
    readonly numberOfEntitiesPerLoad: number = 9999;
    public childEntities: Array<Entity> = [];
    public entitiesLoading: boolean = false;
    private entityCall = {
        options: {
            'filter[name]': '',
            'sort': '-created_at'
        }
    };
    private page: number = 1;
    private maxPages: number = 1;

    // /Infinite Scroll Messages

    constructor(
        private api: ApiService,
        private messenger: MessagesService,
        private modalService: NgbModal,
        private toastNotification: ToastNotificationService,
        private cd: ChangeDetectorRef,
        private entities: EntitiesService,
        private nmos: NewMessageObserverService,
        public user: UserService
    ) {
    }

    ngOnInit() {
        this.initialSync();
    }

    public debouncedInitialSync = debounce(this.initialSync, 500);

    initialSync() {
        const vm = this;

        vm.entitiesLoading = true;
        vm.childEntities = [];
        vm.page = 1;
        vm.entityCall.options['filter[name]'] = vm.searchString;

        // Get the list of users
        if (this.messageType === 'diary') {
            this.entities
                .all(vm.numberOfEntitiesPerLoad, this.page, vm.entityCall.options)
                .then((data: Paginator<Entity>) => {
                    vm.childEntities = vm.sortEntities(data['data']);
                    vm.page++;
                    vm.entitiesLoading = false;
                    vm.maxPages = data.meta.last_page;
                });
        } else {
            let extra_active_id = '&filter[name]=' + vm.searchString;
            if (this.activeId) {
                extra_active_id = '&filter[id]=' + vm.activeId + ''
            };
            this.api
                .get(
                    'v1/entities/message-channels/' +
                    vm.messageType +
                    '?page=' +
                    vm.page +
                    '&limit=' +
                    vm.numberOfEntitiesPerLoad +
                    '&' +
                    vm.messageChannelSort +
                    extra_active_id
                )
                .then(data => {
                    vm.childEntities = vm.sortEntities(data['data']);
                    vm.page++;
                    vm.entitiesLoading = false;
                    // The below is set to 1 because we disable lazy load due to the API not giving the pagination details.
                    vm.maxPages = 1; // data['meta']['last_page'];
                });
        }
    }

    sortEntities(entities) {
        return sortByNewestTimestamp<Entity>(entities, ['updated_at', 'created_at']);
    }

    displayEntityCreatedTimestamp(entity) {
        return displayMessageTimestamp(entity && entity.created_at);
    }

    displayEntityUpdatedTimestamp(entity) {
        return displayMessageTimestamp(entity && entity.updated_at);
    }

    onEntitiesScrollDown() {
        this.entitiesNextPage();
    }

    private entitiesNextPage() {
        const vm = this;
        if (vm.page <= vm.maxPages) {
            vm.entitiesLoading = true;

            if (this.messageType === 'diary') {
                this.entities
                    .all(vm.numberOfEntitiesPerLoad, this.page, vm.entityCall.options)
                    .then(data => {
                        for (const entity of data.data) {
                            if (!vm.entityAlreadyExists(entity.id)) {
                                vm.childEntities.push(entity);
                            }
                        }
                        vm.page++;
                        vm.maxPages = data.meta.last_page;
                        vm.entitiesLoading = false;
                    });
            } else {
                this.api
                    .get(
                        'v1/entities/message-channels/' +
                        vm.messageType +
                        '?page=' +
                        vm.page +
                        '&limit=' +
                        vm.numberOfEntitiesPerLoad +
                        '&' +
                        vm.messageChannelSort +
                        '&filter[name]=' +
                        vm.searchString
                    )
                    .then(data => {
                        for (const entity of data['data']) {
                            if (!vm.entityAlreadyExists(entity.id)) {
                                vm.childEntities.push(entity);
                            }
                        }

                        vm.childEntities = vm.sortEntities(vm.childEntities);
                        vm.page++;
                        vm.maxPages = data['meta']['last_page'];
                        vm.entitiesLoading = false;
                    });
            }
        }
    }

    private entityAlreadyExists(id) {
        for (const entity of this.childEntities) {
            if (entity.id === id) {
                return true;
            }
        }
        return false;
    }

    selectEntity(entity) {
        if (this.messageType === 'chat') {
            const newCount =
                this.nmos.newMessagesCount -
                entity.meta['unread_' + this.messageType + '_message_count'];
            this.nmos.newMessagesCount = newCount >= 0 ? newCount : 0;
        }

        entity.meta['unread_' + this.messageType + '_message_count'] = '';
        this.selectedEntity = entity;
    }

    isSelectedEntity(entity) {
        if (!this.selectedEntity) {
            return false;
        }
        return this.selectedEntity.id === entity.id;
    }

    public currentModal: NgbModalRef;

    openModal(content) {
        this.resetModalSteps();
        this.currentModal = this.modalService.open(content, {
            size: 'lg',
            backdrop : 'static',
            keyboard : false
        });
        this.currentModal.result.then(result => {
        }, reason => {
        });
    }

    resetModalSteps() {
        this.massMessageStep = 0;
        this.base64UploadedFiles = [];
        this.diaryMessage = '';
    }

    closeModal($event) {
        this.sent = false;
        this.sending = false;
        this.currentModal.close($event);
    }

    checkFile(file: File) {
        const valid_image_types = [
            'image/jpeg',
            'image/png',
            'image/bmp',
            'image/gif',
            'image/svg+xml'
        ];

        if (file.size > 250 * 1000000) {
            return (
                'Bestand te groot. ' +
                (file.size / 1000000).toFixed(2) +
                'MB  groter dan 250 MB.'
            );
        } else {
            if ($.inArray(file.type, valid_image_types) < 0) {
                return 'Ongeldig bestandstype: ' + file.type;
            }
            return '';
        }
    }

    onFileChange(event) {
        const vm = this;
        if (event.target.files && event.target.files.length) {
            const files = event.target.files;

            for (const file of files) {
                const reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = () => {
                    vm.filesToUpload.push(file);
                    const error: string = vm.checkFile(file);
                    if (error === '') {
                        vm.base64UploadedFiles.push({
                            data: reader.result,
                            filename: file.name,
                            extra: ''
                        });
                    } else {
                        vm.failedFiles.push({
                            data: reader.result,
                            filename: file.name,
                            extra: error
                        });
                    }
                    this.cd.markForCheck();
                };
            }
        }
    }

    uploadPhoto() {
        this.file.nativeElement.click();
    }

    deleteUploadedFile(i: number) {
        this.base64UploadedFiles.splice(i, 1);
    }

    createEntry($event) {
        this.massMessageStep = 1;
        this.modalSelectedEntities = $event;
    }

    public sending: boolean = false;
    public sent: boolean = false;
    public sendingInfo: string = '';
    public amountMessages: number = 0;

    sendEntry() {
        if (!this.sending) {
            const vm = this;
            vm.sending = true;
            vm.sendingInfo = 'Bericht versturen...';
            this.messenger
                .send(
                    this.modalSelectedEntities,
                    this.diaryMessage,
                    this.messageType,
                    [] // this.base64UploadedFiles
                )
                .then(res => {
                    if ('errors' in res && res['errors'].length !== 0) {
                        vm.toastNotification.showError(res['message']);
                        for (const error in res['errors']) {
                            if (res['errors'].hasOwnProperty(error)) {
                                for (const message of res['errors'][error]) {
                                    vm.toastNotification.showError(message);
                                }
                                // vm.toastNotification.showError(res['errors'][error], error);
                            }
                        }
                        vm.sending = false;
                    } else {
                        // Upload Images
                        if (res['data']['id']) {
                            vm.sendingInfo = 'Afbeeldingen verzenden...';
                            vm.messenger
                                .addPictures(res['data']['id'], vm.filesToUpload)
                                .then(() => {
                                    vm.chatChannel.loadInitialMessages();
                                    vm.sent = true;
                                    vm.amountMessages = vm.modalSelectedEntities.length;
                                })
                                .catch(() => {
                                    vm.sending = false;
                                });
                        } else {
                            vm.toastNotification.showError('Message not sent!');
                            vm.sending = false;
                        }
                    }
                })
                .catch((reason: HttpErrorResponse) => {
                    let error = 'Error! ' + reason.message;
                    if (reason.status === 413 || reason.status === 0) {
                        error = 'Totaal aantal bestanden overschrijdt 50 MB.';
                    }
                    vm.toastNotification.showError(error);
                    vm.sending = false;
                });
        } else {
            alert('We sturen nog steeds het laatste bericht.');
        }
    }
}
